<template>
  <div v-if="password" class="mt-2">
    <div class="d-flex align-items-center mb-1">
      <div class="progress flex-grow-1" style="height: 4px">
        <div
          class="progress-bar"
          :class="barClass"
          role="progressbar"
          :style="{ width: score + '%' }"
          :aria-valuenow="score"
          aria-valuemin="0"
          aria-valuemax="100"
        />
      </div>
      <small class="text-black-50 ml-2">{{ label }}</small>
    </div>
    <ul class="list-unstyled mb-0">
      <li v-for="rule in rules" :key="rule.label" :class="rule.met ? 'text-success' : 'text-black-50'">
        <small>
          <i :class="rule.met ? 'fas fa-check' : 'far fa-circle'" class="mr-1" />
          {{ rule.label }}
        </small>
      </li>
    </ul>
  </div>
</template>

<script>
import { PASSWORD_MIN_LENGTH } from '../../common/constants';

export default {
  name: 'PasswordStrengthMeter',

  props: {
    password: { type: String, default: '' },
  },

  computed: {
    rules() {
      const password = this.password || '';
      return [
        { label: `At least ${PASSWORD_MIN_LENGTH} characters`, met: password.length >= PASSWORD_MIN_LENGTH },
        { label: 'One uppercase letter', met: /[A-Z]/.test(password) },
        { label: 'One lowercase letter', met: /[a-z]/.test(password) },
        { label: 'One number', met: /\d/.test(password) },
        { label: 'One special character', met: /[^A-Za-z0-9]/.test(password) },
      ];
    },

    metCount() {
      return this.rules.filter(rule => rule.met).length;
    },

    score() {
      return Math.round((this.metCount / this.rules.length) * 100);
    },

    label() {
      if (this.metCount === this.rules.length) return 'Strong';
      return this.metCount >= 3 ? 'Medium' : 'Weak';
    },

    barClass() {
      if (this.metCount === this.rules.length) return 'bg-success';
      return this.metCount >= 3 ? 'bg-warning' : 'bg-danger';
    },
  },
};
</script>
